module.exports = __webpack_public_path__ + "resource/img/image019.c5e8d654.png";